// Translations for the wedding website

export const translations = {
  fr: {
    // Navigation
    nav: {
      home: "Accueil",
      story: "Notre Histoire",
      details: "Le Mariage",
      gallery: "Galerie",
      program: "Programme",
      rsvp: "RSVP"
    },
    
    // Hero Section
    hero: {
      sayYes: "se disent oui",
      date: "1er Mai 2027",
      location: "Domaine Tarenti, Mornag, Tunisie",
      discover: "Découvrir l'invitation",
      days: "JOURS",
      hours: "HEURES",
      minutes: "MINUTES",
      seconds: "SECONDES"
    },
    
    // Welcome Section
    welcome: {
      title: "Un mot pour vous",
      message: "Chers amis, chère famille,\n\nC'est avec une immense joie et beaucoup d'émotion que nous vous invitons à partager avec nous le plus beau jour de notre vie.\n\nVotre présence à nos côtés pour célébrer notre union est le plus précieux des cadeaux. Ensemble, nous créerons des souvenirs inoubliables qui resteront gravés dans nos cœurs pour toujours.\n\nMerci d'être là."
    },
    
    // Our Story Section
    story: {
      title: "Notre Histoire",
      content: "Notre histoire a commencé… et elle continue de naître à chaque sourire, à chaque instant passé ensemble 💫\n\nUne rencontre qui a changé nos vies pour le meilleur."
    },
    
    // Wedding Details Section
    details: {
      title: "Le Mariage",
      date: "Date",
      dateValue: "1er Mai 2027",
      time: "Heure",
      timeValue: "À partir de 16h00",
      location: "Lieu",
      locationName: "Domaine Tarenti",
      locationAddress: "1135 Chebbeda BP75, Mornag, Tunisie",
      venueTitle: "À propos du lieu",
      venueDescription: "Le Domaine Tarenti est un lieu d'exception niché au cœur de Mornag. Son cadre enchanteur, ses jardins verdoyants et son architecture élégante en font le lieu idéal pour célébrer notre union.",
      directions: "Obtenir l'itinéraire"
    },
    
    // Gallery Section
    gallery: {
      title: "Nos Moments"
    },
    
    // Program Section
    program: {
      title: "Programme de la Journée",
      items: [
        {
          time: "16h00",
          title: "Accueil des invités",
          description: "Station soft au Domaine Tarenti"
        },
        {
          time: "17h00",
          title: "Cérémonie",
          description: "Signature du contrat de mariage"
        },
        {
          time: "18h00",
          title: "Réception & Restauration",
          description: "Stands gourmands, buffet raffiné et espaces jeux"
        },
        {
          time: "20h00",
          title: "Soirée dansante",
          description: "Animation musicale en live"
        },
        {
          time: "00h00",
          title: "Feu de camp & Marshmallows",
          description: "Moment convivial autour du feu"
        },
        {
          time: "01h00",
          title: "Départ",
          description: "Fin de soirée"
        }
      ]
    },
    
    // RSVP Section
    rsvp: {
      title: "Confirmez votre présence",
      subtitle: "Votre présence illuminera notre journée. Le Domaine Tarenti a besoin d'une liste d'invités exhaustive pour vous offrir une fête merveilleuse.",
      thankYou: "Merci pour votre confirmation !",
      thankYouMessage: "Nous avons bien reçu votre réponse et nous sommes impatients de célébrer ce moment avec vous.",
      form: {
        firstName: "Prénom",
        lastName: "Nom",
        attendance: "Serez-vous des nôtres ?",
        attendanceYes: "Oui, avec plaisir !",
        attendanceNo: "Non, malheureusement",
        guestCount: "Nombre de personnes",
        guestNames: "Nom(s) des personnes",
        message: "Message (optionnel)",
        messagePlaceholder: "Partagez vos vœux ou demandes particulières...",
        submit: "Confirmer ma présence"
      }
    },
    
    // Couple Message Section
    message: {
      title: "Un message de notre cœur",
      content: "Chers amis, chère famille,\n\nChaque moment passé à préparer cette journée nous rappelle à quel point nous sommes chanceux de vous avoir dans nos vies. Votre amour, votre soutien et votre présence ont toujours été précieux pour nous.\n\nCe jour sera encore plus beau parce que vous serez là pour le partager avec nous. Nous avons hâte de créer ensemble des souvenirs qui resteront gravés dans nos cœurs pour toujours.\n\nMerci d'être une part si importante de notre histoire.\n\nAvec tout notre amour,\nHatem & Nourhene"
    },
    
    // Footer
    footer: {
      madeWith: "Créé avec",
      by: "par"
    }
  },
  
  en: {
    // Navigation
    nav: {
      home: "Home",
      story: "Our Story",
      details: "The Wedding",
      gallery: "Gallery",
      program: "Schedule",
      rsvp: "RSVP"
    },
    
    // Hero Section
    hero: {
      sayYes: "are getting married",
      date: "May 1st, 2027",
      location: "Domaine Tarenti, Mornag, Tunisia",
      discover: "Discover the invitation",
      days: "DAYS",
      hours: "HOURS",
      minutes: "MINUTES",
      seconds: "SECONDS"
    },
    
    // Welcome Section
    welcome: {
      title: "A Word for You",
      message: "Dear friends, dear family,\n\nIt is with immense joy and deep emotion that we invite you to share with us the most beautiful day of our lives.\n\nYour presence by our side to celebrate our union is the most precious gift. Together, we will create unforgettable memories that will remain engraved in our hearts forever.\n\nThank you for being there."
    },
    
    // Our Story Section
    story: {
      title: "Our Story",
      content: "Our story began… and it continues to be born with every smile, every moment spent together 💫\n\nA meeting that changed our lives for the better."
    },
    
    // Wedding Details Section
    details: {
      title: "The Wedding",
      date: "Date",
      dateValue: "May 1st, 2027",
      time: "Time",
      timeValue: "From 4:00 PM",
      location: "Location",
      locationName: "Domaine Tarenti",
      locationAddress: "1135 Chebbeda BP75, Mornag, Tunisia",
      venueTitle: "About the Venue",
      venueDescription: "Domaine Tarenti is an exceptional venue nestled in the heart of Mornag. Its enchanting setting, lush gardens, and elegant architecture make it the ideal place to celebrate our union.",
      directions: "Get Directions"
    },
    
    // Gallery Section
    gallery: {
      title: "Our Moments"
    },
    
    // Program Section
    program: {
      title: "Wedding Schedule",
      items: [
        {
          time: "4:00 PM",
          title: "Guest Reception",
          description: "Soft drinks station at Domaine Tarenti"
        },
        {
          time: "5:00 PM",
          title: "Ceremony",
          description: "Marriage contract signing"
        },
        {
          time: "6:00 PM",
          title: "Reception & Dining",
          description: "Gourmet stands, refined buffet and game areas"
        },
        {
          time: "8:00 PM",
          title: "Dancing Party",
          description: "Live musical entertainment"
        },
        {
          time: "12:00 AM",
          title: "Bonfire & Marshmallows",
          description: "Friendly moment around the fire"
        },
        {
          time: "1:00 AM",
          title: "Departure",
          description: "End of evening"
        }
      ]
    },
    
    // RSVP Section
    rsvp: {
      title: "Confirm Your Presence",
      subtitle: "Your presence will light up our day. Domaine Tarenti needs a comprehensive guest list to offer you a wonderful celebration.",
      thankYou: "Thank you for your confirmation!",
      thankYouMessage: "We have received your response and we look forward to celebrating this moment with you.",
      form: {
        firstName: "First Name",
        lastName: "Last Name",
        attendance: "Will you join us?",
        attendanceYes: "Yes, with pleasure!",
        attendanceNo: "No, unfortunately",
        guestCount: "Number of guests",
        guestNames: "Guest name(s)",
        message: "Message (optional)",
        messagePlaceholder: "Share your wishes or special requests...",
        submit: "Confirm Attendance"
      }
    },
    
    // Couple Message Section
    message: {
      title: "A Message from Our Hearts",
      content: "Dear friends, dear family,\n\nEvery moment spent preparing this day reminds us how fortunate we are to have you in our lives. Your love, support, and presence have always been precious to us.\n\nThis day will be even more beautiful because you will be there to share it with us. We look forward to creating memories together that will remain engraved in our hearts forever.\n\nThank you for being such an important part of our story.\n\nWith all our love,\nHatem & Nourhene"
    },
    
    // Footer
    footer: {
      madeWith: "Made with",
      by: "by"
    }
  },
  
  ar: {
    // Navigation
    nav: {
      home: "الرئيسية",
      story: "قصتنا",
      details: "حفل الزفاف",
      gallery: "معرض الصور",
      program: "البرنامج",
      rsvp: "تأكيد الحضور"
    },
    
    // Hero Section
    hero: {
      sayYes: "يقولان نعم",
      date: "1 مايو 2027",
      location: "دومين تارنتي، مرناق، تونس",
      discover: "اكتشف الدعوة",
      days: "أيام",
      hours: "ساعات",
      minutes: "دقائق",
      seconds: "ثواني"
    },
    
    // Welcome Section
    welcome: {
      title: "كلمة لكم",
      message: "أعزائنا الأصدقاء، عائلتنا الغالية،\n\nبفرح عظيم وعاطفة كبيرة، ندعوكم لمشاركتنا أجمل يوم في حياتنا.\n\nحضوركم إلى جانبنا للاحتفال بزواجنا هو أثمن هدية. معاً، سنخلق ذكريات لا تُنسى ستبقى محفورة في قلوبنا إلى الأبد.\n\nشكراً لوجودكم."
    },
    
    // Our Story Section
    story: {
      title: "قصتنا",
      content: "بدأت قصتنا... وهي تستمر في الولادة مع كل ابتسامة، مع كل لحظة نقضيها معاً 💫\n\nلقاء غير حياتنا نحو الأفضل."
    },
    
    // Wedding Details Section
    details: {
      title: "حفل الزفاف",
      date: "التاريخ",
      dateValue: "1 مايو 2027",
      time: "الوقت",
      timeValue: "ابتداءً من الساعة 16:00",
      location: "المكان",
      locationName: "دومين تارنتي",
      locationAddress: "1135 شبيدة BP75، مرناق، تونس",
      venueTitle: "عن المكان",
      venueDescription: "دومين تارنتي هو مكان استثنائي يقع في قلب مرناق. بيئته الساحرة وحدائقه الخضراء وهندسته المعمارية الأنيقة تجعله المكان المثالي للاحتفال بزواجنا.",
      directions: "الحصول على الاتجاهات"
    },
    
    // Gallery Section
    gallery: {
      title: "لحظاتنا"
    },
    
    // Program Section
    program: {
      title: "برنامج اليوم",
      items: [
        {
          time: "16:00",
          title: "استقبال الضيوف",
          description: "محطة المشروبات في دومين تارنتي"
        },
        {
          time: "17:00",
          title: "الحفل",
          description: "التوقيع على عقد الزواج"
        },
        {
          time: "18:00",
          title: "الاستقبال والطعام",
          description: "أكشاك طعام فاخرة ومنطقة ألعاب"
        },
        {
          time: "20:00",
          title: "حفلة الرقص",
          description: "ترفيه موسيقي مباشر"
        },
        {
          time: "00:00",
          title: "نار المخيم والمارشميلو",
          description: "لحظة ودية حول النار"
        },
        {
          time: "01:00",
          title: "المغادرة",
          description: "نهاية السهرة"
        }
      ]
    },
    
    // RSVP Section
    rsvp: {
      title: "أكد حضورك",
      subtitle: "حضوركم سينير يومنا. يحتاج دومين تارنتي إلى قائمة شاملة بالضيوف لتقديم احتفال رائع لكم.",
      thankYou: "شكراً لتأكيدك!",
      thankYouMessage: "لقد تلقينا ردك ونتطلع للاحتفال بهذه اللحظة معك.",
      form: {
        firstName: "الاسم الأول",
        lastName: "اسم العائلة",
        attendance: "هل ستنضم إلينا؟",
        attendanceYes: "نعم، بكل سرور!",
        attendanceNo: "لا، للأسف",
        guestCount: "عدد الضيوف",
        guestNames: "أسماء الضيوف",
        message: "رسالة (اختياري)",
        messagePlaceholder: "شارك تمنياتك أو طلباتك الخاصة...",
        submit: "تأكيد الحضور"
      }
    },
    
    // Couple Message Section
    message: {
      title: "رسالة من قلبنا",
      content: "أعزائنا الأصدقاء، عائلتنا الغالية،\n\nكل لحظة نقضيها في التحضير لهذا اليوم تذكرنا بمدى حظنا بوجودكم في حياتنا. حبكم ودعمكم وحضوركم كان دائماً ثميناً بالنسبة لنا.\n\nسيكون هذا اليوم أجمل لأنكم ستكونون هناك لمشاركته معنا. نتطلع لخلق ذكريات معاً ستبقى محفورة في قلوبنا إلى الأبد.\n\nشكراً لكونكم جزءاً مهماً من قصتنا.\n\nبكل حبنا،\nحاتم ونورهان"
    },
    
    // Footer
    footer: {
      madeWith: "صنع بـ",
      by: "بواسطة"
    }
  }
};
